/** Accesso: Microsoft (SSO Entra, pattern B) o login di sviluppo. «Chiedi l'accesso» dopo un accesso Entra senza ruolo. */
import { Alert, Button, Card, Input, List, Space, Tag, Typography } from "antd";
import { useQuery } from "@tanstack/react-query";
import { Navigate, useNavigate, useSearchParams } from "react-router-dom";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { API_PREFIX } from "@qa/shared";
import { api, ApiError } from "../api/client";
import { useAuth } from "../auth/AuthContext";
import { messaggioErrore, testoChiave } from "../i18n/errori";
import { SelettoreLingua } from "../components/SelettoreLingua";
import { palette } from "../theme";

interface DevUser {
  id: string;
  nome: string;
  email: string;
  ruoli: string[];
}

export default function LoginPage() {
  const { t } = useTranslation();
  const { me, refresh } = useAuth();
  const [params] = useSearchParams();
  const nav = useNavigate();
  const fromParam = params.get("from") || "/";
  const from = fromParam.startsWith("/") && !fromParam.startsWith("//") ? fromParam : "/";
  const [err, setErr] = useState<string | null>(params.get("errore") ? testoChiave(params.get("errore")) : null);
  const [inviata, setInviata] = useState(false);
  const [motivo, setMotivo] = useState("");
  const richiesta = params.get("richiesta") === "1";
  const cfg = useQuery({ queryKey: ["auth-config"], queryFn: () => api.get<{ sso: boolean; devLogin: boolean }>("/auth/config") });
  const devUsers = useQuery({ queryKey: ["dev-users"], queryFn: () => api.get<DevUser[]>("/auth/dev-users"), enabled: !!cfg.data?.devLogin });
  if (me) return <Navigate to={from} replace />;

  const devLogin = async (id: string) => {
    try {
      await api.post("/auth/dev-login", { utenteId: id });
      await refresh();
      nav(from, { replace: true });
    } catch (e) {
      setErr(e instanceof ApiError && e.key ? testoChiave(e.key) : messaggioErrore(e));
    }
  };
  const chiedi = async () => {
    try {
      await api.post("/auth/richiesta-accesso", { motivo: motivo.trim() || null });
      setInviata(true);
    } catch (e) {
      setErr(messaggioErrore(e));
    }
  };

  return (
    <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", background: palette.bg, padding: 16 }}>
      <Card style={{ width: "100%", maxWidth: 440 }} styles={{ body: { padding: 32 } }}>
        <Space direction="vertical" size={16} style={{ width: "100%", textAlign: "center" }}>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <SelettoreLingua connesso={false} />
          </div>
          <div>
            <div style={{ width: 48, height: 48, borderRadius: 12, background: palette.nav, color: "#fff", display: "grid", placeItems: "center", fontWeight: 800, margin: "0 auto 12px" }}>QA</div>
            <Typography.Title level={3} style={{ margin: 0 }}>
              {t("portale.titolo")}
            </Typography.Title>
            <Typography.Text type="secondary">{t("login.sottotitolo")}</Typography.Text>
          </div>
          {err && <Alert type="error" showIcon message={err} style={{ textAlign: "left" }} />}
          {cfg.data?.sso && (
            <Button type="primary" size="large" block href={`${API_PREFIX}/auth/sso/login?from=${encodeURIComponent(from)}`}>
              {t("login.microsoft")}
            </Button>
          )}
          {richiesta &&
            (inviata ? (
              <Alert type="success" showIcon message={t("login.inviata")} style={{ textAlign: "left" }} />
            ) : (
              <Space direction="vertical" style={{ width: "100%", textAlign: "left" }}>
                <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                  {t("login.senzaAccesso")}
                </Typography.Text>
                <Input.TextArea rows={2} maxLength={1000} placeholder={t("login.motivo")} value={motivo} onChange={(e) => setMotivo(e.target.value)} />
                <Button block onClick={() => void chiedi()}>
                  {t("login.chiedi")}
                </Button>
              </Space>
            ))}
          {!richiesta && (
            <Typography.Text type="secondary" style={{ fontSize: 12 }}>
              {t("login.senzaAccesso")}
            </Typography.Text>
          )}
          {cfg.data?.devLogin && (
            <List
              size="small"
              header={<b>{t("login.sviluppo")}</b>}
              style={{ textAlign: "left" }}
              dataSource={devUsers.data ?? []}
              renderItem={(u) => (
                <List.Item
                  actions={[
                    <Button key="e" size="small" onClick={() => void devLogin(u.id)}>
                      {t("login.entra")}
                    </Button>,
                  ]}
                >
                  {u.nome}{" "}
                  {u.ruoli.map((r) => (
                    <Tag key={r} className="mono">
                      {r}
                    </Tag>
                  ))}
                </List.Item>
              )}
            />
          )}
        </Space>
      </Card>
    </div>
  );
}
